import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {Observable} from 'rxjs';
import {PagedRequestDTO} from '../../common/models/PagedRequestDTO';
import {PagedResponseDTO} from '../../common/models/PagedResponseDTO';
import {RulesEngineMetadataDTO} from '../models/RulesEngineMetadataDTO';

@Injectable({
  providedIn: 'root'
})
export class RulesEngineMetadataService {
  private url = environment.baseWeUrl + '/rules-engine-metadata';

  constructor(private httpClient: HttpClient) {
  }

  getListOfRulesEngineMetadata(pagedRequestDTO: PagedRequestDTO): Observable<PagedResponseDTO<RulesEngineMetadataDTO>> {
    return this.httpClient.post<PagedResponseDTO<RulesEngineMetadataDTO>>(this.url + '/filter', pagedRequestDTO);
  }

  getRulesEngineMetadataBy(rulesEngineMetadataId: bigint): Observable<RulesEngineMetadataDTO> {
    return this.httpClient.get<RulesEngineMetadataDTO>(`${this.url}/${rulesEngineMetadataId}`);
  }

  saveRulesEngineMetadata(rulesEngineMetadataDTO: RulesEngineMetadataDTO) {
    return this.httpClient.post<RulesEngineMetadataDTO>(`${this.url}/`, rulesEngineMetadataDTO);
  }

}
